import { createSelector } from 'reselect';
import { MOBILE_HISTORY_INFO_TYPES } from "../../mobileAppCore/components/MobileHistory/mobileHistoryConstants";

const moduleSelector = state => state.account;

export const getAccountPortfolio = createSelector(
    moduleSelector,
    state => state.portfolio
);

export const makeSelectTradingToken = () =>
    createSelector(
        moduleSelector,
        state => state.tradingToken,
    );
export const makeSelectTradingTokenGetting = () =>
    createSelector(
        moduleSelector,
        state => state.tradingTokenGetting,
    );

export const makeSelectCurrentBalance = () =>
    createSelector(
        moduleSelector,
        state => state.portfolio?.balance ?? 0,
    );

export const makeSelectCurrentEquity = () =>
    createSelector(
        moduleSelector,
        state => state.portfolio?.equity ?? 0,
    );

export const makeSelectDepositAvailableMethods = () =>
    createSelector(
        moduleSelector,
        state => state.depositAvailableMethods,
    );

export const getDepositAvailableMethodsLoading = createSelector(
    moduleSelector, state => state.depositAvailableMethodsLoading,
);

export const makeSelectPayoutAvailableMethods = () =>
    createSelector(
        moduleSelector,
        state => state.payoutAvailableMethods,
    );

export const makeSelectPayoutForm = () =>
    createSelector(
        moduleSelector,
        state => state.payoutForm,
    );

export const getDepositForm = createSelector(
    moduleSelector,
    state => state.depositForm,
);

export const getTransactionHistory = createSelector(
    moduleSelector, state => state.transactionHistory,
);

export const makeSelectPayments = () =>
    createSelector(
        moduleSelector,
        state => state.payments,
    );

export const makeSelectPayoutError = () =>
    createSelector(
        moduleSelector,
        state => state.error,
    );

export const makeSelectDepositParams = () =>
    createSelector(
        moduleSelector,
        state => state.depositParams,
    );

export const getPayoutParams = createSelector(
    moduleSelector, state => state.payoutParams || {}
);

export const getPayoutLastDeposit = createSelector(
    getPayoutParams, state => state.lastDeposit
);

export const getUserConfirmEmailLoading = createSelector(
    moduleSelector, state => state.confirmEmailLoading
);

export const getUserConfirmEmailRequestTime = createSelector(
    moduleSelector, state => state.confirmEmailRequestTime
);

export const getDepositCreateSuccessPayload = createSelector(moduleSelector, state => state.depositCreateSuccessPayload);
export const getDepositCreateProcess = createSelector(moduleSelector, state => state.depositCreateProcess);

export const getIsCheckDepositSurvey = createSelector(moduleSelector, state => state.isCheckDepositSurvey);

export const getAccountSelectedHistoryInfo = createSelector(
    moduleSelector, state => state.selectedHistoryInfo,
);

export const getAccountSelectedTransactionInfo = createSelector(
    getAccountSelectedHistoryInfo, state => state[MOBILE_HISTORY_INFO_TYPES.TRANSACTION],
);

export const getAccountSelectedPositionInfo = createSelector(
    getAccountSelectedHistoryInfo, state => state[MOBILE_HISTORY_INFO_TYPES.POSITION],
);

export const getAccountHistory = createSelector(
    moduleSelector, state => state.history,
);
